export default "__VITE_ASSET__C1zvYS40__"